/**
 * I don't want the spread number in the code that have no meaning
 * to other developers. That's why I buid this class
 */
export class DoenkidsStaticValuesHelper {
  static readonly ORGANIZATION_UNIT_TYPE_NODE = 1;

  static readonly ORGANIZATION_UNIT_TYPE_CUSTOMER = 2;

  static readonly ORGANIZATION_UNIT_TYPE_LOCATION = 3;

  static readonly ORGANIZATION_UNIT_TYPE_GROUP = 4;

  static readonly DOENKIDS_IDENTIFIER = 1;

  static readonly ACTIVITY_READER_ROLE = 1;

  static readonly ACTIVITY_EDITOR_ROLE = 2;

  static readonly ACTIVITY_OWNER_ROLE = 3;

  static readonly ACTIVITY_REVOKED_ROLE = 4;

  static readonly PROGRAM_READER_ROLE = 1;

  static readonly PROGRAM_EDITOR_ROLE = 2;

  static readonly PROGRAM_OWNER_ROLE = 3;

  static readonly PROGRAM_REVOKED_ROLE = 4;

  static readonly ACTIVITY_STATUS_CONCEPT = 1;

  static readonly ACTIVITY_STATUS_REVIEW = 2;

  static readonly ACTIVITY_STATUS_PUBLISHED = 3;

  static readonly ACTIVITY_STATUS_UNPUBLISHED = 4;

}
